import '../../styles/editcase/ResultsTabs.css';

const TABS = [
    { key: 'facts', label: 'Facts' },
    { key: 'timeline', label: 'Timeline' },
];

export const tabId = (key) => `results-tab-${key}`;
export const panelId = (key) => `results-tabpanel-${key}`;

/**
 * Tab strip for the Review & Approve stage.
 *
 * Pair with `<div role="tabpanel" id={panelId(key)} aria-labelledby={tabId(key)}>`
 * around each panel's content for an a11y-complete pattern.
 *
 * @param {Object}   props
 * @param {'facts'|'timeline'} props.currentTab
 * @param {function} props.onTabChange – Called with tab key.
 */
export default function ResultsTabs({ currentTab, onTabChange }) {
    const handleKeyDown = (e) => {
        const idx = TABS.findIndex((t) => t.key === currentTab);
        let next = null;
        if (e.key === 'ArrowRight') next = (idx + 1) % TABS.length;
        else if (e.key === 'ArrowLeft') next = (idx - 1 + TABS.length) % TABS.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = TABS.length - 1;
        if (next === null) return;
        e.preventDefault();
        onTabChange(TABS[next].key);
        document.getElementById(tabId(TABS[next].key))?.focus();
    };

    return (
        <div className="results-tabs" role="tablist" onKeyDown={handleKeyDown}>
            {TABS.map((tab) => {
                const selected = currentTab === tab.key;
                return (
                    <button
                        key={tab.key}
                        id={tabId(tab.key)}
                        role="tab"
                        aria-selected={selected}
                        // Panels render conditionally, so only the selected
                        // tab's panel exists to point at
                        aria-controls={selected ? panelId(tab.key) : undefined}
                        tabIndex={selected ? 0 : -1}
                        className={`results-tab ${selected ? 'results-tab--active' : ''}`}
                        onClick={() => onTabChange(tab.key)}
                        type="button"
                    >
                        {tab.label}
                    </button>
                );
            })}
        </div>
    );
}
